// extracted by mini-css-extract-plugin
export default {"stringInput":"ezv4pZDO"};